export const searchColumns = ["mobile", "main_cab_no"];

export const driverData = [
  {
    full_name: "Ram Kumar",
    phone_number: "9876543210",
    status: "Online",
    driver_type: "Primary",
    subscription: "SCO",
    cab_number: "KA-50-A-6573",
    current_ride: "BNC922030082",
  },

  {
    full_name: "Ram Kumar",
    phone_number: "9876543210",
    status: "Online",
    driver_type: "Primary",
    subscription: "SCO",
    cab_number: "KA-50-A-6573",
    current_ride: "BNC922030082",
  },

  {
    full_name: "Ram Kumar",
    phone_number: "9876543210",
    status: "Online",
    driver_type: "Primary",
    subscription: "SCO",
    cab_number: "KA-50-A-6573",
    current_ride: "BNC922030082",
  },

  {
    full_name: "Ram Kumar",
    phone_number: "9876543210",
    status: "Online",
    driver_type: "Primary",
    subscription: "SCO",
    cab_number: "KA-50-A-6573",
    current_ride: "BNC922030082",
  },

  {
    full_name: "Ram Kumar",
    phone_number: "9876543210",
    status: "Online",
    driver_type: "Primary",
    subscription: "SCO",
    cab_number: "KA-50-A-6573",
    current_ride: "BNC922030082",
  },

  {
    full_name: "Ram Kumar",
    phone_number: "9876543210",
    status: "Online",
    driver_type: "Primary",
    subscription: "SCO",
    cab_number: "KA-50-A-6573",
    current_ride: "BNC922030082",
  },

  {
    full_name: "Ram Kumar",
    phone_number: "9876543210",
    status: "Online",
    driver_type: "Primary",
    subscription: "SCO",
    cab_number: "KA-50-A-6573",
    current_ride: "BNC922030082",
  },

  {
    full_name: "Ram Kumar",
    phone_number: "9876543210",
    status: "Online",
    driver_type: "Primary",
    subscription: "SCO",
    cab_number: "KA-50-A-6573",
    current_ride: "BNC922030082",
  },

  {
    full_name: "Ram Kumar",
    phone_number: "9876543210",
    status: "Online",
    driver_type: "Primary",
    subscription: "SCO",
    cab_number: "KA-50-A-6573",
    current_ride: "BNC922030082",
  },
  {
    full_name: "Ram Kumar",
    phone_number: "9876543210",
    status: "Online",
    driver_type: "Primary",
    subscription: "SCO",
    cab_number: "KA-50-A-6573",
    current_ride: "BNC922030082",
  },
  {
    full_name: "Ram Kumar",
    phone_number: "9876543210",
    status: "Online",
    driver_type: "Primary",
    subscription: "SCO",
    cab_number: "KA-50-A-6573",
    current_ride: "BNC922030082",
  },

  {
    full_name: "Ram Kumar",
    phone_number: "9876543210",
    status: "Online",
    driver_type: "Primary",
    subscription: "SCO",
    cab_number: "KA-50-A-6573",
    current_ride: "BNC922030082",
  },

  {
    full_name: "Ram Kumar",
    phone_number: "9876543210",
    status: "Online",
    driver_type: "Primary",
    subscription: "SCO",
    cab_number: "KA-50-A-6573",
    current_ride: "BNC922030082",
  },

  {
    full_name: "Ram Kumar",
    phone_number: "9876543210",
    status: "Online",
    driver_type: "Primary",
    subscription: "SCO",
    cab_number: "KA-50-A-6573",
    current_ride: "BNC922030082",
  },

  {
    full_name: "Ram Kumar",
    phone_number: "9876543210",
    status: "Online",
    driver_type: "Primary",
    subscription: "SCO",
    cab_number: "KA-50-A-6573",
    current_ride: "BNC922030082",
  },

  {
    full_name: "Ram Kumar",
    phone_number: "9876543210",
    status: "Online",
    driver_type: "Primary",
    subscription: "SCO",
    cab_number: "KA-50-A-6573",
    current_ride: "BNC922030082",
  },

  {
    full_name: "Ram Kumar",
    phone_number: "9876543210",
    status: "Online",
    driver_type: "Primary",
    subscription: "SCO",
    cab_number: "KA-50-A-6573",
    current_ride: "BNC922030082",
  },
];

export const driverFilterColumns = [
  {
    name: "FULL NAME",
    value: "full_name",
    type: "text",
  },
  {
    name: "PHONE #",
    value: "mobile",
    type: "text",
  },
  // {
  //     name: 'STATUS',
  //     value:'driver_status',
  //     type:'text'
  // },
  // {
  //     name: 'Available',
  //     value:'driver_avilable',
  //     type:'text'
  // },
  // {
  //     name: 'DRIVER TYPE',
  //     value:'driver_type',
  //     type:'text'
  // },
  // {
  //     name: 'SUBSCRIPTION',
  //     value:'driver_type'
  // },
  {
    name: "CAB NUMBER",
    value: "main_cab_no",
    type: "text",
  },
  // {
  //     name: 'CURRENT RIDE',
  //     selector: row => row['current_ride'],
  //     sortable: true,
  //     center: true,
  //     // width:"100px",
  // },
];

export const driverColumns = [
  {
    name: "FULL NAME",
    selector: (row) => row["full_name"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  {
    name: "PHONE",
    selector: (row) => row["phone_number"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  // {
  //   name: "STATUS",
  //   selector: (row) => row["status"],
  //   sortable: true,
  //   center: true,
  //   // width:"130px",
  // },
  {
    name: "AVAILABLE",
    selector: (row) => row["isAvailable"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  {
    name: "BLOCKED REASON",
    selector: (row) => row["blockedReason"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  {
    name: "DRIVER TYPE",
    selector: (row) => row["driver_type"],
    sortable: true,
    center: true,
    // width:"130px",
  },
  // {
  //     name: 'SUBSCRIPTION',
  //     selector: row => row['subscription'],
  //     sortable: true,
  //     center: true,
  //     // maxWidth:"7vw",
  // },
  {
    name: "CAB NUMBER",
    selector: (row) => row["cab_number"],
    sortable: true,
    center: true,
    // maxWidth:"7vw",
  },
  // {
  //     name: 'CURRENT RIDE',
  //     selector: row => row['current_ride'],
  //     sortable: true,
  //     center: true,
  //     // width:"100px",
  // },
  {
    name: "",
    selector: (row) => row["action"],
    sortable: true,
    center: true,
    width: "50px",
    // style: {
    //   backgroundColor: "white",
    //   position: "sticky",
    //   right: 0,
    //   zIndex: 0,
    //   justifyContent: "center !important"
    // },
  },
];
